module.exports = __webpack_public_path__ + "onboarding-spaces.13a777c39630e8f352ba289638e3dde2.hashedasset.svg";